import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {KontaAppRoutingModule} from './konta-app-routing.module';
import {KontaAppComponent} from './konta-app.component';
import {TopBarComponent} from './components/top-bar/top-bar.component';

import { MatButtonModule } from '@angular/material/button';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import {TranslateModule} from '@ngx-translate/core';

@NgModule({
    declarations: [KontaAppComponent, TopBarComponent],
    imports: [
        CommonModule,
        KontaAppRoutingModule,
        MatToolbarModule,
        MatButtonModule,
        MatSidenavModule,
        MatIconModule,
        MatListModule,
        MatGridListModule,
        MatMenuModule,
        TranslateModule
    ],
    exports: [KontaAppComponent]
})
export class KontaAppModule {
}
